import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3" }
const _hoisted_2 = { class: "text-right" }
const _hoisted_3 = {
  key: 1,
  class: "h-40 px-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_thumbnail = _resolveComponent("video-thumbnail")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-subtitle-underline" }, "最近見た動画（閲覧履歴）", -1)),
    (Array.isArray(_ctx.browsings) && _ctx.browsings.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.browsings, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                (item.video)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/video/${item.video.id}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_video_thumbnail, {
                          video: item.video
                        }, null, 8, ["video"])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: "/video/browsing-history",
              class: "text-link text-sm"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" すべての閲覧履歴を見る> ", -1)
              ]))]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " 最近見た動画はありませんでした。 "))
  ], 64))
}